import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { usePrototype } from './PrototypeContext'
import '../LobbyScreen.css'
import './prototype.css'

// War history (the bottom bar's): the wars under way, then the last ten ended.
export default function WarHistory() {
    const { uid, wars, openWar, goHome } = usePrototype()
    const mySeat = (w) => (w.players.p1.uid === uid ? 'p1' : 'p2')
    const opponent = (w) => w.players[mySeat(w) === 'p1' ? 'p2' : 'p1']
    const active = wars.filter(w => w.status === 'active')
    const ended = wars.filter(w => w.status !== 'active').slice(0, 10)

    return (
        <div className="pt-screen">
            <header className="pt-menu__head">
                <button className="pt-back" onClick={goHome} aria-label="Back to home">
                    <FontAwesomeIcon icon={faChevronLeft} />
                </button>
                <h1 className="pt-menu__title">War history</h1>
            </header>

            <div className="pt-wars">
                {!active.length && !ended.length && <p className="pt-dim pt-wars__none">No wars yet.</p>}
                {active.map(w => {
                    const seat = mySeat(w)
                    return (
                        <button key={w.id} className="pt-war" onClick={() => openWar(w.id)}>
                            <span>{opponent(w).name ?? 'A friend'}</span>
                            <span className="pt-dim">{w.mode} · round {w.roundNumber}</span>
                            <span className={w.submitted[seat] ? 'pt-dim' : 'pt-turn'}>{w.submitted[seat] ? 'waiting' : 'your move'}</span>
                        </button>
                    )
                })}
                {ended.map(w => {
                    const seat = mySeat(w)
                    const r = w.result
                    const outcome = !r ? '' : r.draw ? 'draw' : r.winner === seat ? 'won' : 'lost'
                    return (
                        <button key={w.id} className="pt-war pt-war--ended" onClick={() => openWar(w.id)}>
                            <span>{opponent(w).name ?? 'A friend'}</span>
                            <span className="pt-dim">{w.mode}</span>
                            <span>{outcome}</span>
                        </button>
                    )
                })}
            </div>
        </div>
    )
}
